// 手机监考
const Proctor = r => require.ensure(
  [],
  () => r(require('@/components/proctor/index.vue')),
  'Proctor'
)
const Equipment = r => require.ensure(
  [],
  () => r(require('@/components/proctor/equipment.vue')),
  'Equipment'
)
export default [
  // 我的活动
  {
    path: '/Proctor',
    name: 'Proctor',
    component: Proctor
  },
  {
    path: '/Equipment',
    name: 'Equipment',
    component: Equipment
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/proctor.js